import styled from 'styled-components';
import useMobile from '../../other/Hooks/useMobile';
import useOrientation from '../../other/Hooks/useOrientation';
import Theme from '../../Theme';

import { Chevron } from '../icons';
import { Text } from './index';

type ContainerProps = {
  position: 'left' | 'right'
}

const Container = styled.div`
  position: fixed;
  top: 0;
  z-index: 11;
  width: 52px;
  height: ${window.innerHeight}px;
  border-top: 1px solid white;
  border-bottom: 1px solid white;
  background-color: rgba(255,255,255,0.5);
  cursor: pointer;

  ${({ position }: ContainerProps) => {
    if (position === 'left') {
      return `
        left: 0;
        border: none;
        border-right: 2px solid white;
      `;
    } else {
      return `
        right: 0;
        border: none;
        border-left: 2px solid white;
        `;
      }
    }}
  @media screen and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
      bottom:0;
      top:auto;
      width:100vw;
      height:48px;
      border: none;
      border-top: 2px solid white;
  }
  .icon-container {
    position: absolute;
    top: 24px;
    left: 50%;
    transform: translateX(-50%);
    @media screen and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
      top:11px;
      left:15px;
      transform:none;
    }

  }

  .chevron-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    @media screen and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
      top:11px;
      right:15px;
      left:auto;
      transform:${({ position }: ContainerProps) => position === 'right' ? 'rotate(90deg)' : 'rotate(-90deg)'};
    }
  }

  p {
    text-align: right;
    position: absolute;
    transform: rotate(90deg);
    width: 300px;
    bottom: 150px;
    left: -130px;
    @media screen and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}) and (orientation:landscape){
      left:51px;
      bottom:auto;
      max-width:75%;
      text-align:center;
      transform:none;
      
    }
  }
`;

const Home = styled.div<{ showBack?: boolean }>`
  width: 53px;
  height: 62px;
  overflow: hidden;
  @media screen  and (max-width:${Theme.devices.mobile}),(max-height:${Theme.devices.mobile}){
    height: 47px;
  }
  background: #ED8B00;
  margin: -1px -2px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ showBack }) => (
    showBack
      ? ``
      : ``
  )}
  


`

type Props = {
  position: 'left' | 'right'
  text: string
  onClick: any
  backToSplit: any
  showBack?: boolean
}

const NavBar = ({ position, text, onClick, backToSplit, showBack }: Props) => {
  const isMobile = useMobile()
  const isLandscape = useOrientation()
  return (
    <Container key={`${isLandscape}`} position={position} onClick={onClick}>
      <Home showBack={showBack}
        onClick={e => {
          e.stopPropagation()
          backToSplit()
        }}>
        {
          showBack === undefined
            ?
            <svg width="28" height="25" viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.2 25V16.1765H16.8V25H23.8V13.2353H28L14 0L0 13.2353H4.2V25H11.2Z" fill="white" />
            </svg>
            : <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 7.5H3.83L9.42 1.81018L8 0.375L0 8.51786L8 16.6607L9.41 15.2255L3.83 9.53572H16V7.5Z" fill="white" />
            </svg>

        }
      </Home>
      <div className='chevron-container'>
        <Chevron size={10} direction={position === 'left' ? isMobile ? 'top' : 'right' : isMobile ? 'bottom' : 'left'} />
      </div>
      <Text variant='Header5'>{text}</Text>
    </Container>
  );
};

export default NavBar;